module.exports = __webpack_public_path__ + "img/alearnA_thumb.65b5af0c.jpg";